import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';

class LightboxImage extends HTMLElement {
  connectedCallback() {
    if (this._inited) return;
    this._inited = true;

    this.lightbox = new PhotoSwipeLightbox({
      gallery: this,
      children: 'a',
      pswpModule: () => import('./photoswipe.esm.min.js'),
      bgOpacity: 0.7,
      showHideAnimationType: 'zoom'
    });

    this.lightbox.init();
  }

  disconnectedCallback() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
    this._inited = false;
  }
}

if (!customElements.get('lightbox-image')) {
  customElements.define('lightbox-image', LightboxImage);
}
